import clerkUserSync from './clerk-user-sync';

export default {
  clerkUserSync,
};
